import { render } from "./StationLightningsHeatmap.vue?vue&type=template&id=bad21994"
import script from "./StationLightningsHeatmap.vue?vue&type=script&lang=js"
export * from "./StationLightningsHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__